import { render, staticRenderFns } from "./list-all-exchange.vue?vue&type=template&id=2d654619"
import script from "./list-all-exchange.vue?vue&type=script&lang=js"
export * from "./list-all-exchange.vue?vue&type=script&lang=js"
import style0 from "./list-all-exchange.vue?vue&type=style&index=0&id=2d654619&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports